// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";

function RegionIndicatorCountryDisplay(props) {
  var r = Belt_Array.get(props.regions, props.selected);
  if (r === undefined) {
    return null;
  }
  var countryText = props.text.replace("{0}", r.name);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: countryText
                  })
            });
}

var make = RegionIndicatorCountryDisplay;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
